import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import StyledRegistrationRequest from "./StyledRegistrationRequest";
import { ROUTE_PATH } from "../../constants/route";

const RegistrationExists = () => {
  return (
    <StyledRegistrationRequest>
      <Box className="registration-wrap">
        <Box className="registration-header">
          <Box className="circleIcon">
            <CheckIcon className="icon-circle" />
          </Box>
          <Box className="header">Registration Request Submitted!</Box>
        </Box>
        <Box className="body-wrap">
          <Typography className="body-text">
            Registration request already exist, action pending from admin. You
            will be notified shortly.
          </Typography>
        </Box>
        <Box className="backLogin">
          <Link to={ROUTE_PATH.DASHBOARD}>Back to Home</Link>
        </Box>
      </Box>
    </StyledRegistrationRequest>
  );
};

export default RegistrationExists;
